import napStyles from './../nap.json'

export default {
  name: '4',
  color: napStyles.colors.PrimaryBlack
}
